import { createRoot } from 'react-dom/client';
import './index.css';
import './utility/debug/crashTrace';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { esES } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/es';
import AppThemeProvider from './utility/theme/AppThemeProvider.tsx';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes.tsx';
import { Provider } from 'react-redux';
import { store } from './redux/store.ts';
import { ToastContainer } from 'react-toastify';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './components/login/msalConfig.ts';
import { MsalProvider } from '@azure/msal-react';
import { initSentry } from './utility/monitoring/sentry.ts';
import { installDomMutationGuards } from './utility/monitoring/domMutationGuards.ts';
import { SentryUserSync } from './utility/monitoring/SentryUserSync.tsx';
import { installResourceUsageMonitor } from './utility/monitoring/resourceUsage.ts';
import { installStaleBuildRecovery } from './utility/deploy/staleBuildRecovery.ts';
import { OfflineProvider } from './offline/OfflineProvider.tsx';

initSentry();
installDomMutationGuards();
installResourceUsageMonitor();
installStaleBuildRecovery();

const msalInstance = new PublicClientApplication(msalConfig);

createRoot(document.getElementById('root') as HTMLElement).render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <OfflineProvider>
        <AppThemeProvider>
          <SentryUserSync />
          <ToastContainer />
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="es"
            localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
          >
            <RouterProvider router={router}></RouterProvider>
          </LocalizationProvider>
        </AppThemeProvider>
      </OfflineProvider>
    </Provider>
  </MsalProvider>
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch((error) => {
      console.warn('No se pudo registrar el service worker de ePos offline.', error);
    });
  });
}
